// Mock data used by both dashboards (customer + vendor). All INR.

export const MOCK_ORDERS = [
  {
    id: "EP-2041",
    product: "Visiting Cards — 500 qty, Matt lamination",
    customer: "TechNova Startup",
    location: "Connaught Place",
    amount: 2400,
    status: "printing",
    placed: "Today, 9:14 am",
    eta: "Same-day by 5pm",
  },
  {
    id: "EP-2039",
    product: "A3 Flyers × 1000",
    customer: "Zara Delhi",
    location: "Saket",
    amount: 5800,
    status: "printing",
    placed: "Today, 8:02 am",
    eta: "Next-day delivery",
  },
  {
    id: "EP-2035",
    product: "6ft Standee × 2",
    customer: "GreenLeaf Café",
    location: "Lajpat Nagar",
    amount: 3200,
    status: "ready",
    placed: "Yesterday",
    eta: "Ready for pickup",
  },
  {
    id: "EP-2018",
    product: "Wedding Cards × 250",
    customer: "Ravi & Priya",
    location: "Noida Sector 62",
    amount: 8750,
    status: "delivered",
    placed: "3 days ago",
    eta: "Delivered",
  },
  {
    id: "EP-2006",
    product: "Product Packaging Boxes × 500",
    customer: "MintChai Co.",
    location: "Gurugram",
    amount: 14500,
    status: "delivered",
    placed: "5 days ago",
    eta: "Delivered",
  },
];

export const MOCK_QUOTES = [
  {
    id: "Q-101",
    spec: "Business cards, 500, 350gsm, matt lamination",
    countdown: "01:24:12",
    vendors: [
      { name: "Bhairo Prints", rating: 4.8, distance: "1.2 km", price: 2200, ready: "Today 5pm", badge: "Lowest Price" },
      { name: "Shakti Digital", rating: 4.9, distance: "2.4 km", price: 2450, ready: "Today 6pm", badge: "Best Rated" },
      { name: "QuickPress", rating: 4.6, distance: "0.8 km", price: 2350, ready: "Today 3pm", badge: "Fastest" },
    ],
  },
];

export const MOCK_VENDORS = [
  { name: "Bhairo Prints", area: "Nehru Place", rating: 4.8, reviews: 231, tags: ["Cards", "Flyers", "Books"], img: "https://images.pexels.com/photos/35317008/pexels-photo-35317008.jpeg?auto=compress&w=600" },
  { name: "Shakti Digital", area: "Connaught Place", rating: 4.9, reviews: 412, tags: ["Packaging", "Stickers"], img: "https://images.pexels.com/photos/38178433/pexels-photo-38178433.jpeg?auto=compress&w=600" },
  { name: "QuickPress", area: "Saket", rating: 4.6, reviews: 178, tags: ["Flex", "Standees"], img: "https://images.unsplash.com/photo-1497215728101-856f4ea42174?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  { name: "Signature Studio", area: "Noida", rating: 4.7, reviews: 302, tags: ["Wedding", "Fine Art"], img: "https://images.unsplash.com/photo-1552664730-d307ca884978?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
];

export const MOCK_TESTIMONIALS = [
  { name: "Anjali M.", role: "Café owner, Lajpat Nagar", quote: "Quoted three different prices at three shops. On EarlyPrint I saw six real quotes side-by-side — done in 20 minutes.", avatar: "https://i.pravatar.cc/80?img=32" },
  { name: "Rohit K.", role: "Founder, TechNova", quote: "The escrow gave me the confidence to test a new vendor. Cards arrived a day early and looked crisp.", avatar: "https://i.pravatar.cc/80?img=12" },
  { name: "Kavita S.", role: "Wedding planner", quote: "Live tracking is a game changer. My clients stop calling me for updates.", avatar: "https://i.pravatar.cc/80?img=45" },
];

export const MOCK_WALLET = {
  balance: 1250,
  transactions: [
    { id: "T-9021", desc: "Refund — cancelled order #EP-2001", amount: +450, at: "Feb 12, 2026" },
    { id: "T-8998", desc: "Cashback — EP-2039", amount: +120, at: "Feb 11, 2026" },
    { id: "T-8971", desc: "Top up (UPI)", amount: +1000, at: "Feb 08, 2026" },
    { id: "T-8955", desc: "Order EP-2018 payment", amount: -8750, at: "Feb 05, 2026" },
  ],
};

export const MOCK_STATS_VENDOR = {
  newLeads: 12,
  inProduction: 8,
  todayEarnings: 4280,
  monthEarnings: 48200,
  rating: 4.7,
  reviews: 31,
  onTime: 97,
  escrowHeld: 12500,
};
